import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ProjectService = {
    
  getAllProject: async () => {
    try {
      const response = await axios.get(ENDPOINT.Project);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

   getLastProject: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Project}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  getAllProjectById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Project}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  getAllActiveProjectById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.activeProject}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

   getProjectDetailsById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Project}/eq/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  createProject: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Project, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  updateProject: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Project}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  deleteProject: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Project}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  createCustomer: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.customer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },

  updateCustomer: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.customer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Project:", error.message);
      throw error;
    }
  },
}